'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  SPORT_CODES: 'sportCodes',
  SPORT_LOV: 'sportList',
  SPORT_REGION_LOV: 'sportRegionList',
  STATE_LOV: 'stateList',
  CONFERENCE_LOV: 'conferenceList',
  RACE_LOV: 'raceList',
  TITLE_LOV: 'titleList',
  COORDINATOR_LOV: 'coordinatorList',
  ELIGIBILITY_LOV: 'eligList',
  TYPE_LOV: 'typeList',
  CURRENT_YEAR: 'currentYear',
  SEARCH: 'orgList',
  ACCRED_AGENCY_LIST: 'accred/agencyList'
}

// Sport Code List
function getDistinctSportCodesEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_CODES
}

// Current Year Sport List
function getCurrentYearSportListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_LOV
}

// State List
function getStateListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.STATE_LOV
}

// Conference List
function getConferenceListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.CONFERENCE_LOV
}

// Ethnicity List
function getRaceListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.RACE_LOV
}

// Title List
function getTitleListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.TITLE_LOV
}

// Coordinator List
function getCoordinatorListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.COORDINATOR_LOV
}
// Eligibility List
function getEligibilityListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.ELIGIBILITY_LOV
}

// Member Type List
function getMemberTypeListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.TYPE_LOV
}

// Current Year
function getCurrentYearEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.CURRENT_YEAR
}

// Organization Search Autocomplete
function getOrgSearchEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SEARCH
}

// Sport Region List
function getSportRegionApiEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_REGION_LOV
}

// Sport Region List for Editor
function getSportRegionEditorApiEndPoint (sportCode, academicYear, division, subdivision) {
  let paramStr = '?academicYear=' + academicYear + '&division=' + division + '&sportCode=' + sportCode + '&subdivision=' + subdivision
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SPORT_REGION_LOV + paramStr
}

function getAccredAgencyListEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.ACCRED_AGENCY_LIST
}

function getDisciplinesBySportEndPoint (sportCode) {
  return `${urls.commonDataApiController()}/disciplines/sport/${sportCode}`
}

function loadStateList () {
  return axios.get(this.getStateListEndPoint())
}

function loadConferenceList () {
  return axios.get(this.getConferenceListEndPoint())
}

function loadSportList (orgId, academicYear, sponsored) {
  let params = {}

  if (orgId) {
    params['orgId'] = orgId
  }

  if (academicYear) {
    params['academicYear'] = academicYear
  }

  if (orgId || academicYear) {
    params['sponsored'] = sponsored
  }

  return axios.get(this.getCurrentYearSportListEndPoint(), {'params': params})
}

function loadSportRegionList (sportCode, academicYear, division, subdivision) {
  return axios.get(getSportRegionApiEndPoint(), {
    params: {
      'sportCode': sportCode,
      'academicYear': academicYear,
      'division': division,
      'subdivision': subdivision
    }
  })
}

function loadRaceList () {
  return axios.get(getRaceListEndPoint())
}

function loadTitleList () {
  return axios.get(getTitleListEndPoint())
}
function loadCoordinatorList () {
  return axios.get(getCoordinatorListEndPoint())
}
function loadTypeList () {
  return axios.get(getMemberTypeListEndPoint())
}

function loadCurrentYear () {
  return axios.get(getCurrentYearEndPoint())
}

function searchOrgs (q) {
  return axios.get(getOrgSearchEndPoint() + '?q=' + q)
}

function loadAccredAgencyList () {
  return axios.get(getAccredAgencyListEndPoint())
}

function loadDisciplinesBySport (sportCode) {
  return axios.get(getDisciplinesBySportEndPoint(sportCode))
}

export default {
  getDistinctSportCodesEndPoint: getDistinctSportCodesEndPoint,
  getCurrentYearSportListEndPoint: getCurrentYearSportListEndPoint,
  getStateListEndPoint: getStateListEndPoint,
  getConferenceListEndPoint: getConferenceListEndPoint,
  getDisciplinesBySportEndPoint: getDisciplinesBySportEndPoint,
  loadStateList: loadStateList,
  loadConferenceList: loadConferenceList,
  loadSportList: loadSportList,
  loadRaceList: loadRaceList,
  loadTitleList: loadTitleList,
  loadCoordinatorList: loadCoordinatorList,
  getEligibilityListEndPoint: getEligibilityListEndPoint,
  loadTypeList: loadTypeList,
  loadCurrentYear: loadCurrentYear,
  getTitleListEndPoint: getTitleListEndPoint,
  searchOrgs: searchOrgs,
  loadSportRegionList: loadSportRegionList,
  getSportRegionEditorApiEndPoint: getSportRegionEditorApiEndPoint,
  loadAccredAgencyList: loadAccredAgencyList,
  loadDisciplinesBySport: loadDisciplinesBySport
}
